import React from 'react';
import { DonutCard } from './DonutCard.component';
import styles from '../DashboardOverviewNew.module.scss';

const EMPTY_SEGMENT = [{ name: '—', value: 100, color: '#E5E7EB' }];

const ACTIVITY_BREAKDOWN_TOOLTIP = {
  description:
    "Splits today's tracked span into Active, Idle, and Offline time, so you can see how much of the day was spent working vs away from the tracker.",
  calculation: {
    formula: 'Active % = Productive time / Total elapsed span × 100',
  },
};

export const ActivityBreakdown = ({ data, isLoading = false, footerTo }) => {
  const { totalTime, label, segments } = data || {
    totalTime: '—',
    label: '—',
    segments: EMPTY_SEGMENT,
  };

  return (
    <DonutCard
      className={styles.chartCardMedium}
      isLoading={isLoading}
      title="Activity Breakdown"
      tooltip={ACTIVITY_BREAKDOWN_TOOLTIP}
      chartSize={160}
      innerRadius={66}
      outerRadius={76}
      segments={segments.map((seg) => ({
        ...seg,
        displayValue: `${seg.value}%`,
      }))}
      centerValue={totalTime}
      centerLabel={label}
      footerLabel="View full timeline"
      footerTo={footerTo}
    />
  );
};
